<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 28.2676H53.8028" stroke="black" stroke-width="4"/>
<path d="M17 32.0422H53.8028" stroke="black" stroke-width="4"/>
<path d="M17 35.8169H53.8028" stroke="black" stroke-width="4"/>
<path d="M26.4366 16H63.5374L70.6894 23.7308L77.3944 30.9462C77.3944 50.6344 77.3944 63.0179 77.3944 83H46.5326H42.5852H38.6378H26.4366V16Z" stroke="black" stroke-width="4"/>
<path d="M33 48H71" stroke="black" stroke-width="4"/>
<path d="M33 59H60" stroke="black" stroke-width="4"/>
<path d="M33 70H48" stroke="black" stroke-width="4"/>
<path d="M62.2958 16.9436V31.0985H77.3944" stroke="black" stroke-width="4"/>
</svg>

</template>
